export default __webpack_public_path__ + "static/media/signup_banner_Hk.1bb13e33.jpg";